import { render, staticRenderFns } from "./ApisList.vue?vue&type=template&id=108d6e9c&"
import script from "./ApisList.vue?vue&type=script&lang=js&"
export * from "./ApisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports